import React from 'react';

export default function TabBar({ tabs, activeTab, setActiveTab }) {
  return (
    <div className="tab-bar">
      {tabs.map(({ key, label }) => (
        <button
          key={key}
          onClick={() => setActiveTab(key)}
          className={`wow-btn ${activeTab === key ? 'wow-btn-primary' : ''}`}
        >
          {label}
        </button>
      ))}
    </div>
  );
}
